import type { QueryClient } from "@tanstack/react-query";
import { $api, fetchClient } from "../generated/client";

export const shopQueryKey = (shopId: string) => [
	"get",
	"/shops/{shopId}",
	{
		params: { path: { shopId: shopId } },
		enabled: !!shopId,
	},
];

export default function useShopSuspense(shopId: string) {
	return $api.useSuspenseQuery("get", "/shops/{shopId}", {
		params: { path: { shopId: shopId! } },
		enabled: !!shopId,
	});
}

export function usePublicShopSuspense(shopId: string) {
	return $api.useSuspenseQuery("get", "/public/shops/{providerId}", {
		params: { path: { providerId: shopId! } },
		enabled: !!shopId,
	});
}

type EnsureShopSuspenseParams = {
	queryClient: QueryClient;
	shopId: string;
};

export function ensureShopSuspense({
	queryClient,
	shopId,
}: EnsureShopSuspenseParams) {
	return queryClient.ensureQueryData({
		queryFn: () =>
			fetchClient.GET("/shops/{shopId}", { params: { path: { shopId } } }),
		queryKey: ["get", "/shops/{shopId}", { params: { path: { shopId } } }],
	});
}
